<div
  class="flex w-60 lg:w-80 rounded-full border bg-surface py-1 text-fg-faint relative pr-0.5"
  [ngClass]="filter.type === 'notSet' ? 'border-edge-strong' : 'border-green-600 text-fg-muted'"
>
  @if (filter.type === 'month' || filter.type === 'year') {
    <div class="flex flex-grow pr-4">
      <button (click)="decrement()" class="ml-1.5 h-6 w-6 rounded-full bg-surface-hover">
        <app-ng-icon strokeWidth="3" name="heroArrowLeft"></app-ng-icon>
      </button>
      <div
        class="flex-grow text-center"
        [class.text-fg-muted]="!isTodayInCurrentPeriod"
        [class.text-blue-700]="isTodayInCurrentPeriod"
      >
        {{ displayText }}
      </div>
      <button (click)="increment()" class="h-6 w-6 rounded-full bg-surface-hover">
        <app-ng-icon strokeWidth="3" name="heroArrowRight"></app-ng-icon>
      </button>
    </div>
    <app-dropdown-minimal-menu class="mr-1">
      <app-dropdown-button>
        <app-ng-icon
          class="text-2xl"
          [class.text-fg-muted]="filter.type === 'month' || filter.type === 'year'"
          strokeWidth="1.5"
          name="heroXCircle"
        ></app-ng-icon>
      </app-dropdown-button>
      <app-dropdown-item (menuClick)="enableFilter('month')">nach Monat </app-dropdown-item>
      <app-dropdown-item (menuClick)="enableFilter('year')">nach Jahr </app-dropdown-item>
      <app-dropdown-item (menuClick)="resetFilter()">Alles </app-dropdown-item>
    </app-dropdown-minimal-menu>
    <!--    <icon-filter></icon-filter>-->
  }
  @if (filter.type === 'notSet') {
    <div class="flex flex-grow pr-4">
      <div class="flex-grow pl-4 font-light">Datum</div>
    </div>
    <app-dropdown-minimal-menu class="mr-1.5">
      <app-dropdown-button>
        <app-ng-icon class="text-xl" strokeWidth="1.5" name="heroFunnel"></app-ng-icon>
      </app-dropdown-button>
      <app-dropdown-item (menuClick)="enableFilter('month')">nach Monat </app-dropdown-item>
      <app-dropdown-item (menuClick)="enableFilter('year')">nach Jahr </app-dropdown-item>
    </app-dropdown-minimal-menu>
  }
  @if (filter.type !== 'notSet' && !isTodayInCurrentPeriod) {
    <button class="absolute left-0 right-0 -bottom-4 text-xs" (click)="goToCurrentPeriod()">
      {{ currentPeriodButtonText }}
    </button>
  }
</div>
